import React from 'react';
import { Box, Icon, Typography } from '@drone-js/core';
import { CmsValue } from 'core/type/BootstrapConfig.types';
import { TextType } from '@drone-js/theme';
import { getDate, getDay, getMonth, parseISO } from 'date-fns';

export type DateChipType = 'DateChip' | 'MoreDates';

interface Props {
    cms: CmsValue;
    date?: Date | string;
    dayNameColor: TextType;
}

const DateTypeDateChip: React.FC<Props> = (props) => {
    if (!props.date) return null;
    const scheduleDate = typeof props.date === 'string' ? parseISO(props.date) : props.date;
    const date = getDate(scheduleDate);
    const translatedWeekdays = props.cms[71412].split(',');
    const day = getDay(scheduleDate);
    const dayName = translatedWeekdays[day];
    const translatedMonths = props.cms[70237].split(',');
    const month = getMonth(scheduleDate);
    const monthName = translatedMonths[month];

    return (
        <Box py="12">
            <Typography variant="body-s-strong">{monthName}</Typography>
            <Typography tag="p" variant="heading-xl">
                {date}
            </Typography>
            <Typography variant="caption-default" textColor={props.dayNameColor}>
                {dayName}
            </Typography>
        </Box>
    );
};
DateTypeDateChip.displayName = 'DateTypeDateChip';

const DateChipContent: React.FC<Props & { type: DateChipType }> = (props) => {
    if (props.type === 'DateChip') {
        return <DateTypeDateChip {...props} />;
    }
    return (
        <Box py="12" display="flex" flexDirection="column" alignItems="center" whiteSpace="normal">
            <Icon id="fill.symbol.calendar" size="24" color="deprecated.secondary.interactive" p="4" />
            <Typography variant="caption-default" textColor="deprecated.secondary.interactive">
                {props.cms[286357]}
            </Typography>
        </Box>
    );
};

DateChipContent.displayName = 'DateChipContent';
export default DateChipContent;
